var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M74 143.067c38.144 0 69.067-30.923 69.067-69.067 0-38.145-30.923-69.067-69.067-69.067C35.855 4.933 4.933 35.855 4.933 74c0 38.144 30.922 69.067 69.067 69.067z",
    stroke: "#F5222D",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.373 101.629l55.253-55.254M101.626 101.629L46.373 46.375",
    stroke: "#F5222D",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgErrorIcon;